<main class="page">

  <!-- Steps -->
  <div class="steps">
    @for (step of steps(); track step.number) {
      <button type="button" class="step" [class.active]="step.active" [class.completed]="step.completed" [disabled]="!isStepClickable(step)" (click)="goToStep(step)">
        <span class="step-number">{{ step.number }}</span>
        <span class="step-label">{{ step.label }}</span>
      </button>
    }
  </div>

  <h1 class="page-title">Step 2a · New Project Details</h1>

  <!-- Form -->
  <div class="form-card">
    <form class="form-grid">

      <!-- Row 1 -->
      <div class="form-group">
        <label class="form-label">Project Title <span class="required">*</span></label>
        <input class="form-input" type="text" [ngModel]="formData().projectTitle" (ngModelChange)="formData.update(f => ({ ...f, projectTitle: $event }))" name="projectTitle" [readonly]="isSubmittedStatus()" [disabled]="isSubmittedStatus()" />
        @if (detailsAttempted() && !formData().projectTitle.trim()) {
          <p class="field-error">Project Title is required.</p>
        }
      </div>
      <div class="form-group">
        <label class="form-label">
          Estimate Request Type <span class="required">*</span>
          <mat-icon class="info-icon" matTooltip="Select the required estimate request type.">info</mat-icon>
        </label>
        <input class="form-select" [ngModel]="formData().estimateRequestType" (ngModelChange)="onAutocompleteValueChange('estimateRequestType', $event)" name="estimateRequestType" placeholder="— Select or type —" autocomplete="off" [matAutocomplete]="npEstimateRequestTypeOptions" #estimateRequestTypeTrigger="matAutocompleteTrigger" (focus)="openAutocomplete('estimateRequestType', estimateRequestTypeTrigger)" (click)="openAutocomplete('estimateRequestType', estimateRequestTypeTrigger)" (blur)="closeAutocomplete('estimateRequestType')" [readonly]="isSubmittedStatus()" [disabled]="isSubmittedStatus()" />
        <mat-autocomplete #npEstimateRequestTypeOptions="matAutocomplete">
          @for (opt of getAutocompleteOptions(estimateRequestTypes, 'estimateRequestType', formData().estimateRequestType); track opt) {
            <mat-option [value]="opt">{{ opt }}</mat-option>
          }
        </mat-autocomplete>
        @if (detailsAttempted() && !formData().estimateRequestType) {
          <p class="field-error">Estimate Request Type is required.</p>
        }
      </div>
      <div class="form-group">
        <label class="form-label">Area <span class="required">*</span></label>
        <input class="form-select" [ngModel]="formData().area" (ngModelChange)="onAutocompleteValueChange('area', $event)" name="area" placeholder="— Select or type —" autocomplete="off" [matAutocomplete]="npAreaOptions" #areaTrigger="matAutocompleteTrigger" (focus)="openAutocomplete('area', areaTrigger)" (click)="openAutocomplete('area', areaTrigger)" (blur)="closeAutocomplete('area')" [readonly]="isSubmittedStatus()" [disabled]="isSubmittedStatus()" />
        <mat-autocomplete #npAreaOptions="matAutocomplete">
          @for (opt of getAutocompleteOptions(areaOptions, 'area', formData().area); track opt) {
            <mat-option [value]="opt">{{ opt }}</mat-option>
          }
        </mat-autocomplete>
        @if (detailsAttempted() && !formData().area) {
          <p class="field-error">Area is required.</p>
        }
      </div>

      <!-- Row 2 -->
      <div class="form-group">
        <label class="form-label">Estimate Title <span class="required">*</span></label>
        <input class="form-input" type="text" [ngModel]="formData().estimateTitle" (ngModelChange)="formData.update(f => ({ ...f, estimateTitle: $event }))" name="estimateTitle" [readonly]="isSubmittedStatus()" [disabled]="isSubmittedStatus()" />
        @if (detailsAttempted() && !formData().estimateTitle.trim()) {
          <p class="field-error">Estimate Title is required.</p>
        }
      </div>
      <div class="form-group">
        <label class="form-label">
          Project Management Type <span class="required">*</span>
          <mat-icon class="info-icon" matTooltip="Select the project management type.">info</mat-icon>
        </label>
        <input class="form-select" [ngModel]="formData().projectManagementType" (ngModelChange)="onProjectManagementTypeChange($event)" name="projectManagementType" placeholder="— Select or type —" autocomplete="off" [matAutocomplete]="npProjectManagementTypeOptions" #projectManagementTypeTrigger="matAutocompleteTrigger" (focus)="openAutocomplete('projectManagementType', projectManagementTypeTrigger)" (click)="openAutocomplete('projectManagementType', projectManagementTypeTrigger)" (blur)="closeAutocomplete('projectManagementType')" [readonly]="isProjectManagementTypeReadonly()" [disabled]="isProjectManagementTypeReadonly()" />
        <mat-autocomplete #npProjectManagementTypeOptions="matAutocomplete">
          @for (opt of getAutocompleteOptions(projectManagementTypes, 'projectManagementType', formData().projectManagementType); track opt) {
            <mat-option [value]="opt">{{ opt }}</mat-option>
          }
        </mat-autocomplete>
        @if (detailsAttempted() && !formData().projectManagementType) {
          <p class="field-error">Project Management Type is required.</p>
        }
      </div>
      <div class="form-group">
        <label class="form-label">Unit <span class="required">*</span></label>
        <input class="form-select" [ngModel]="formData().unit" (ngModelChange)="onAutocompleteValueChange('unit', $event)" name="unit" placeholder="— Select or type —" autocomplete="off" [matAutocomplete]="npUnitOptions" #unitTrigger="matAutocompleteTrigger" (focus)="openAutocomplete('unit', unitTrigger)" (click)="openAutocomplete('unit', unitTrigger)" (blur)="closeAutocomplete('unit')" [readonly]="isSubmittedStatus()" [disabled]="isSubmittedStatus()" />
        <mat-autocomplete #npUnitOptions="matAutocomplete">
          @for (opt of getAutocompleteOptions(unitOptions, 'unit', formData().unit); track opt) {
            <mat-option [value]="opt">{{ opt }}</mat-option>
          }
        </mat-autocomplete>
        @if (detailsAttempted() && !formData().unit) {
          <p class="field-error">Unit is required.</p>
        }
      </div>

      <!-- Row 3 -->
      <div class="form-group">
        <label class="form-label">Project Number <span class="required">*</span></label>
        <input class="form-input" type="text" [ngModel]="formData().projectNumber" (ngModelChange)="formData.update(f => ({ ...f, projectNumber: $event }))" name="projectNumber" [readonly]="isSubmittedStatus()" [disabled]="isSubmittedStatus()" />
        @if (detailsAttempted() && !formData().projectNumber.trim()) {
          <p class="field-error">Project Number is required.</p>
        }
      </div>
      <div class="form-group">
        <label class="form-label">CPDEP Phase <span class="required">*</span></label>
        <input class="form-select readonly-field" [ngModel]="formData().cpdepPhase" (ngModelChange)="onAutocompleteValueChange('cpdepPhase', $event)" name="cpdepPhase" placeholder="— Auto-filled —" autocomplete="off" readonly [matAutocomplete]="npCpdepPhaseOptions" #cpdepPhaseTrigger="matAutocompleteTrigger" />
        <mat-autocomplete #npCpdepPhaseOptions="matAutocomplete">
          @for (opt of getAutocompleteOptions(cpdepPhases, 'cpdepPhase', formData().cpdepPhase); track opt) {
            <mat-option [value]="opt">{{ opt }}</mat-option>
          }
        </mat-autocomplete>
        @if (detailsAttempted() && !formData().cpdepPhase) {
          <p class="field-error">CPDEP Phase is required.</p>
        }
      </div>
      <div class="form-group">
        <label class="form-label">IBP Year<span class="required">*</span></label>
        <input class="form-select" [ngModel]="formData().ibp" (ngModelChange)="onAutocompleteValueChange('ibp', $event)" name="ibp" placeholder="— Select or type —" autocomplete="off" [matAutocomplete]="npIbpOptions" #ibpTrigger="matAutocompleteTrigger" (focus)="openAutocomplete('ibp', ibpTrigger)" (click)="openAutocomplete('ibp', ibpTrigger)" (blur)="closeAutocomplete('ibp')" [readonly]="isSubmittedStatus()" [disabled]="isSubmittedStatus()" />
        <mat-autocomplete #npIbpOptions="matAutocomplete">
          @for (opt of getAutocompleteOptions(ibpOptions, 'ibp', formData().ibp); track opt) {
            <mat-option [value]="opt">{{ opt }}</mat-option>
          }
        </mat-autocomplete>
        @if (detailsAttempted() && !formData().ibp) {
          <p class="field-error">IBP Year is required.</p>
        }
      </div>

      <!-- Row 4 -->
      <div class="form-group">
        <label class="form-label">Project Code</label>
        <input class="form-input" type="text" [ngModel]="formData().projectCode" (ngModelChange)="formData.update(f => ({ ...f, projectCode: $event }))" name="projectCode" [readonly]="isSubmittedStatus()" [disabled]="isSubmittedStatus()" />
      </div>
      <div class="form-group">
        <label class="form-label">Design progress <span class="required">*</span></label>
        <input class="form-select readonly-field" [ngModel]="formData().designProgress" (ngModelChange)="onAutocompleteValueChange('designProgress', $event)" name="designProgress" placeholder="— Auto-filled —" autocomplete="off" readonly [matAutocomplete]="npDesignProgressOptions" #designProgressTrigger="matAutocompleteTrigger" />
        <mat-autocomplete #npDesignProgressOptions="matAutocomplete">
          @for (opt of getAutocompleteOptions(designProgressOptions, 'designProgress', formData().designProgress); track opt) {
            <mat-option [value]="opt">{{ opt }}</mat-option>
          }
        </mat-autocomplete>
        @if (detailsAttempted() && !formData().designProgress) {
          <p class="field-error">Design progress is required.</p>
        }
      </div>
      <div class="form-group">
        <label class="form-label">TA Year <span class="required">*</span></label>
        <input class="form-select" [ngModel]="formData().taYear" (ngModelChange)="onAutocompleteValueChange('taYear', $event)" name="taYear" placeholder="— Select or type —" autocomplete="off" [matAutocomplete]="npTaYearOptions" #taYearTrigger="matAutocompleteTrigger" (focus)="openAutocomplete('taYear', taYearTrigger)" (click)="openAutocomplete('taYear', taYearTrigger)" (blur)="closeAutocomplete('taYear')" [readonly]="isSubmittedStatus()" [disabled]="isSubmittedStatus()" />
        <mat-autocomplete #npTaYearOptions="matAutocomplete">
          @for (opt of getAutocompleteOptions(taYearOptions, 'taYear', formData().taYear); track opt) {
            <mat-option [value]="opt">{{ opt }}</mat-option>
          }
        </mat-autocomplete>
        @if (detailsAttempted() && !formData().taYear) {
          <p class="field-error">TA Year is required.</p>
        }
      </div>

      <!-- Row 5 -->
      <div class="form-group"></div>
      <div class="form-group">
        <label class="form-label">Planned Project Completion Date <span class="required">*</span></label>
        <input class="form-input" type="date" [ngModel]="formData().anticipatedCompletionDate" (ngModelChange)="formData.update(f => ({ ...f, anticipatedCompletionDate: $event }))" name="anticipatedCompletionDate" (click)="openDatePicker($event)" [readonly]="isSubmittedStatus()" [disabled]="isSubmittedStatus()" />
        @if (detailsAttempted() && !formData().anticipatedCompletionDate) {
          <p class="field-error">Planned Project Completion Date is required.</p>
        }
      </div>
      <div class="form-group">
        <label class="form-label">Preliminary Cost Estimate Deadline <span class="required">*</span></label>
        <input class="form-input" type="date" [ngModel]="formData().preliminaryCostDeadline" (ngModelChange)="formData.update(f => ({ ...f, preliminaryCostDeadline: $event }))" name="preliminaryCostDeadline" (click)="openDatePicker($event)" [readonly]="isSubmittedStatus()" [disabled]="isSubmittedStatus()" />
        @if (detailsAttempted() && !formData().preliminaryCostDeadline) {
          <p class="field-error">Preliminary Cost Estimate Deadline is required.</p>
        }
      </div>

    </form>
  </div>

  <!-- Actions -->
  <div class="actions">
    <button class="btn btn-secondary" type="button" (click)="goBack()">‹ Back to Step 1</button>
    <div class="actions-right">
      @if (shouldShowSaveDraft()) {
        <button class="btn btn-outline" type="button" (click)="saveDraft()" [disabled]="isSubmittedStatus()">Save Draft</button>
      }
      @if (shouldShowSave()) {
        <button class="btn btn-outline" type="button" (click)="save()" [disabled]="isSubmittedStatus()">Save</button>
      }
      <button class="btn btn-primary" type="button" (click)="goToQuestionnaire()">Go To Questionnaire ›</button>
    </div>
  </div>

  @if (showPmtConfirmModal()) {
    <div class="modal-backdrop" (click)="cancelPmtChange()"></div>
    <div class="confirm-modal">
      <p class="confirm-modal__title">Change Project Management Type</p>
      <p class="confirm-modal__message">
        You are about to change Project Management Type. If you click &ldquo;YES&rdquo; all your answers in the Questionnaire (step 3) will be removed. Please click checkbox to auto-download your answers. &ldquo;CANCEL&rdquo; if you don&rsquo;t wish to continue.
      </p>
      <label class="confirm-modal__checkbox">
        <input
          type="checkbox"
          [ngModel]="autoDownloadAnswers()"
          (ngModelChange)="autoDownloadAnswers.set($event)"
        />
        <span>Auto-download questionnaire answers</span>
      </label>
      <div class="confirm-modal__actions">
        <button type="button" class="btn-confirm btn-confirm--cancel" (click)="cancelPmtChange()">Cancel</button>
        <button type="button" class="btn-confirm btn-confirm--confirm" [disabled]="isDownloadingAnswers()" (click)="confirmPmtChange()">
          {{ isDownloadingAnswers() ? 'Downloading...' : 'Yes' }}
        </button>
      </div>
    </div>
  }

</main>
